module.exports = __webpack_public_path__ + "static/media/icon-open.5c2ba842.svg";